import React from 'react';
import DefaultButtonContainer from '../../Componant/Buttons/Default';

const DefaultButton = () => {
  return (
    <div className='page-body'>
      <DefaultButtonContainer />
    </div>
  );
};

export default DefaultButton;
